"use client";

import { RenderFilters } from "@/lib/blocks/render-filters";
import { getRelationshipObject, resolveRelationshipId } from "@/lib/utils/theme-configuration-class";
import { cn } from "@/lib/utils";
import { useForm } from "@tanstack/react-form-nextjs";
import { useTranslations } from "next-intl";
import { X } from "lucide-react";
import { Button } from "@/components/frontend/ui/button";
import { usePartnerOverview } from "./context";

export function PartnerOverviewFilters() {
	const { filters, selectedFilters, defaultSelectedFilters, hasAppliedFilters, onFiltersChange, settings } = usePartnerOverview();
	const filterset = getRelationshipObject(filters?.filterset);
	const form = useForm({ defaultValues: selectedFilters });
	const t = useTranslations("ms");

	if (!filterset?.filters?.length) return null;

	return (
		<form
			className={cn("ms-form-" + resolveRelationshipId(settings?.filterFormVariant), "w-full space-y-3.5")}
			onSubmit={(event) => {
				event.preventDefault();
				event.stopPropagation();
				form.handleSubmit();
			}}
		>
			<RenderFilters
				filterset={filterset}
				defaultFilters={filters?.defaultFilters}
				selectedFilters={selectedFilters}
				form={form}
				formVariant={settings?.filterFormVariant}
				onValueChange={(value, blockType) => onFiltersChange({ ...selectedFilters, [blockType]: value })}
			/>

			{hasAppliedFilters && (
				<Button
					className="w-full justify-center"
					variant="subtle"
					type="button"
					onClick={() => {
						form.reset(defaultSelectedFilters);
						onFiltersChange({});
					}}
				>
					<X className="size-4" />
					{t("partner-overview.remove-filters")}
				</Button>
			)}
		</form>
	);
}
